// extracted by mini-css-extract-plugin
export default {"active":"jotKPsJoUdlT87qS5u9k DbQ767nBquSyaa8gg5vF","icon":"uryNW_wJzvCEozMUzAkP HR7uEhI1Br60TIierOgU"};